export var LOCATION_LEVELS;
(function (LOCATION_LEVELS) {
    LOCATION_LEVELS["LEVEL_DISTRICT"] = "STADTTEILEBENE";
    LOCATION_LEVELS["LEVEL_CITY"] = "STADTEBENE";
    LOCATION_LEVELS["LEVEL_CIRCLE"] = "KREISEBENE";
    LOCATION_LEVELS["LEVEL_STATE"] = "LANDESEBENE";
    LOCATION_LEVELS["LEVEL_NATION"] = "BUNDESEBENE";
    LOCATION_LEVELS["LEVEL_REGION"] = "REGIONSEBENE";
})(LOCATION_LEVELS || (LOCATION_LEVELS = {}));
//# sourceMappingURL=locationAutocomplete.js.map